<style>
.loader {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 9999;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #8B008B;
  width: 80px;
  height: 80px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.overlay {
  z-index:9998;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: grey;
  opacity: 0.5
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<template>
  <div id="app" style="min-height:600px;">
    <div class="main-wrapper">
      <div class="navbar-bg"></div>
      <div class="overlay" v-if="this.$root.is_loading"></div>
      <div class="loader" v-if="this.$root.is_loading"></div>
      <app-sidebar v-if="sidebar" :menus.sync="menuList" :show.sync="sidebar"></app-sidebar>
      <app-topbar v-if="topbar" :show.sync="topbar"></app-topbar>
      <router-view v-if="reRender" :key="$route.fullPath"/>
      <footer class="main-footer">
        <div class="footer-left">
          Copyright &copy; 2019 <div class="bullet"></div>
        </div>
        <div class="footer-right">
          2.3.0
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import topbar from './components/template/Topbar.vue';
import sidebar from './components/template/Sidebar.vue';
import { setTimeout } from 'timers';
import auth from "./components/auth/Auth";

export default {
  name: 'app',
  data: function()
  {
    return {
      last_route : '',
      reRender : true,
      topbar : false,
      sidebar : false,
      kevin: 'ok',
      menuList : {
        produksi : false,
        penjualan : false,
        pembelian : false,
        stocking : false,
        dashboard : false,
        dashboardMenu : false,
        laporan : false,
        pembiayaan : false,
        finance : false,
        setting : false,
        produk : false,
      },
      toastr : [],
      notificationSystem: {
        options: {
          show: {
            theme: "dark",
            icon: "icon-person",
            position: "topCenter",
            progressBarColor: "rgb(0, 255, 184)",
            buttons: [
              [
                "<button>Ok</button>",
                function(instance, toast) {
                  alert("Hello world!");
                },
                true
              ],
              [
                "<button>Close</button>",
                function(instance, toast) {
                  instance.hide(
                    {
                      transitionOut: "fadeOutUp",
                      onClosing: function(instance, toast, closedBy) {
                        console.info("closedBy: " + closedBy);
                      }
                    },
                    toast,
                    "buttonName"
                  );
                }
              ]
            ],
            onOpening: function(instance, toast) {
              console.info("callback abriu!");
            },
            onClosing: function(instance, toast, closedBy) {
              console.info("closedBy: " + closedBy);
            }
          },
          ballon: {
            balloon: true,
            position: "topRight"
          },
          info: {
            position: "topRight"
          },
          success: {
            position: "topRight"
          },
          warning: {
            position: "topRight"
          },
          error: {
            position: "topRight"
          },
          question: {
            timeout: 20000,
            close: false,
            overlay: true,
            toastOnce: true,
            id: "question",
            zindex: 999,
            position: "center",
            buttons: [
              [
                "<button><b>YES</b></button>",
                function(instance, toast) {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
                true
              ],
              [
                "<button>NO</button>",
                function(instance, toast) {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                }
              ]
            ],
            onClosing: function(instance, toast, closedBy) {
              console.info("Closing | closedBy: " + closedBy);
            },
            onClosed: function(instance, toast, closedBy) {
              console.info("Closed | closedBy: " + closedBy);
            }
          }
        }
      },
      isprice : ''
    }
  },
  components: {
   'app-topbar' : topbar,
   'app-sidebar' : sidebar,
  },
  mounted: function() {
    this.checkHeader()
  },
  methods: {
    init: function() {
        this.$http.get("Auth/getMenu/"+window.localStorage.getItem('id_level')).then(result => {
          if(result.data.code == '01') {
              if(window.localStorage.getItem('id_level') == 1){
                this.menuList.produksi = true
                this.menuList.penjualan = true
                this.menuList.pembelian = true
                this.menuList.stocking = true
                this.menuList.dashboard = true
                this.menuList.dashboardMenu = true
                this.menuList.laporan = true
                this.menuList.pembiayaan = true
                this.menuList.finance = true
                this.menuList.setting = true
                this.menuList.produk = true
              }else if(window.localStorage.getItem('id_level') == 2){
                this.menuList.dashboard = true
                this.menuList.dashboardMenu = true
                this.menuList.laporan = true
                this.menuList.stocking = true
                this.menuList.produk = true
              }else if(window.localStorage.getItem('id_level') == 3){
                this.menuList.stocking = true
                this.menuList.penjualan = true
                this.menuList.pembelian = true
                this.menuList.produk = true
                // this.$router.replace('/penjualan/list/pemesanan-penjualan')
              }else if(window.localStorage.getItem('id_level') == 4) {
                this.menuList.stocking = true
                this.menuList.pembelian = true
                this.menuList.produk = true
                this.menuList.penjualan = true
                // this.$router.replace('/pembelian/list/pemesanan-pembelian')
              }else if(window.localStorage.getItem('id_level') == 5) {
                this.menuList.stocking = true
                this.menuList.produksi = true
                this.menuList.produk = true
                // this.$router.replace('/produksi')
              }
              this.isprice = window.localStorage.getItem('is_price') == '1' ? true : false
          }
          else if(result.data.code == '02') {
              alert('Sesimu telah berakhir , kamu akan logout')
              this.topbar = this.sidebar = false
              auth.logout(); 
          }else {
              alert('Kamu tidak terotorisasi mengakses halaman ini , kamu akan logout')
              this.topbar = this.sidebar = false
              auth.logout();                
          }
        }, error => {
          console.log('gk ok')
            context.errors = errors;
        });
    },
    checkHeader: function() {
      if(window.localStorage.getItem('token')) {
        this.topbar = this.sidebar = true
        this.init();
      }else {
        this.topbar = this.sidebar = false
      }
    },
    runToast: function() {
      if(this.toastr.type == 'success'){
        this.$toast.success(this.toastr.message,this.toastr.title,this.notificationSystem.options.success)
      }else if(this.toastr.type == 'error'){
        this.$toast.error(this.toastr.message,this.toastr.title,this.notificationSystem.options.error)
      }else if(this.toastr.type == 'warning'){
        this.$toast.warning(this.toastr.message,this.toastr.title,this.notificationSystem.options.warning)
      }
    },
    reRendering: function() {
      this.reRender = false;
      this.$nextTick(function(){
        this.reRender = true;
      })
    },
    setLastRoute: function() {
        this.last_route = window.localStorage.getItem('last_route');
    },
    currencyFormat: function(val){
      if(window.localStorage.getItem('is_price') == '1'){
        if(val == null){
          return '-'
        }else {
          return (parseFloat(val)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
      }else {
        return '-'
      }
    },
  },
  watch: {
    'toastr' : function(){
      this.runToast();
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue